import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import AppTogglers, { 
  ConsultantSessionInfoToggler, 
  UserMasterAppSettingsToggler, 
  KPITargetSettingsToggler,
  FixedSessionSettingsToggler,
  MenuSettingsToggler,
  KnowledgeDataSettingsToggler,
  QuickQuerySettingsToggler,
  ConsultantHomeBannerDataToggler,
  AudioCallSettingsToggler,
} from '../../components/uniques/app-togglers';
import SettingsIcon from '@mui/icons-material/Settings';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [fixedSubTab, setFixedSubTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <SettingsIcon style={{ fontSize: '28px', color: '#1976d2' }} />
            <h4 className="Title">Settings</h4>
          </div>
        </div>

        <div style={{ padding: '20px' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange}
              aria-label="settings tabs"
              sx={{
                '& .MuiTab-root': {
                  fontSize: '16px',
                  fontWeight: 500,
                  textTransform: 'none',
                  minHeight: '48px',
                },
                '& .Mui-selected': {
                  color: '#1976d2',
                  fontWeight: 600,
                },
              }}
            >
              <Tab label="Consultant App Settings" />
              <Tab label="User App Settings" />
              <Tab label="Fixed Session Settings" />
            </Tabs>
          </Box>

          {/* Consultant App Settings Tab */}
          <TabPanel value={activeTab} index={0}>
            <div style={{ marginBottom: '30px' }}>
              <Typography variant="h5" gutterBottom style={{ 
                marginBottom: '20px', 
                color: '#333',
                fontWeight: 600 
              }}>
                Consultant App Settings
              </Typography>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: '30px' }}>
                Configure settings for the Consultant mobile application
              </Typography>

              {/* Android & iOS Settings Section */}
              <div style={{ marginBottom: '30px' }}>
                <Typography variant="h6" gutterBottom style={{ 
                  marginBottom: '15px',
                  color: '#1976d2',
                  fontWeight: 600,
                  paddingBottom: '10px',
                  borderBottom: '2px solid #e0e0e0'
                }}>
                  Free Consultation Settings
                </Typography>
                <AppTogglers />
              </div>

              <div style={{ marginBottom: '30px' }}>
                <Typography variant="h6" gutterBottom style={{
                  marginBottom: '15px',
                  color: '#1976d2',
                  fontWeight: 600,
                  paddingBottom: '10px',
                  borderBottom: '2px solid #e0e0e0'
                }}>
                  Audio Call Settings
                </Typography>
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-fill" style={{ minWidth: '300px', flexBasis: 'calc(50% - 0.75rem)' }}>
                    <AudioCallSettingsToggler />
                  </div>
                </div>
              </div>

              {/* Consultant Master Settings Section */}
              <div style={{ marginBottom: '30px' }}>
                <Typography variant="h6" gutterBottom style={{ 
                  marginBottom: '15px',
                  color: '#1976d2',
                  fontWeight: 600,
                  paddingBottom: '10px',
                  borderBottom: '2px solid #e0e0e0'
                }}>
                  Consultant Master Settings
                </Typography>
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-fill" style={{ minWidth: '300px', flexBasis: 'calc(50% - 0.75rem)' }}>
                    <ConsultantSessionInfoToggler />
                  </div>
                </div>
              </div>

              {/* KPI Settings Section */}
              <div style={{ marginBottom: '30px' }}>
                <Typography variant="h6" gutterBottom style={{ 
                  marginBottom: '15px',
                  color: '#1976d2',
                  fontWeight: 600,
                  paddingBottom: '10px',
                  borderBottom: '2px solid #e0e0e0'
                }}>
                  KPI Target Settings
                </Typography>
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-fill" style={{ minWidth: '300px', flexBasis: '100%' }}>
                    <KPITargetSettingsToggler />
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>

          {/* User App Settings Tab */}
          <TabPanel value={activeTab} index={1}>
            <div style={{ marginBottom: '30px' }}>
              <Typography variant="h5" gutterBottom style={{ 
                marginBottom: '20px', 
                color: '#333',
                fontWeight: 600 
              }}>
                User App Settings
              </Typography>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: '30px' }}>
                Configure settings for the User mobile application
              </Typography>

              {/* User Master Settings Section */}
              <div style={{ marginBottom: '30px' }}>
                <Typography variant="h6" gutterBottom style={{ 
                  marginBottom: '15px',
                  color: '#1976d2',
                  fontWeight: 600,
                  paddingBottom: '10px',
                  borderBottom: '2px solid #e0e0e0'
                }}>
                  User Master Settings
                </Typography>
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-fill" style={{ minWidth: '300px', flexBasis: 'calc(50% - 0.75rem)' }}>
                    <UserMasterAppSettingsToggler />
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>

          {/* Fixed Session Settings Tab */}
          <TabPanel value={activeTab} index={2}>
            <div style={{ marginBottom: '30px' }}>
           
             

              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                  value={fixedSubTab}
                  onChange={(_e, v) => setFixedSubTab(v)}
                  aria-label="fixed session settings sub tabs"
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    '& .MuiTab-root': {
                      fontSize: '14px',
                      fontWeight: 500,
                      textTransform: 'none',
                      minHeight: '44px',
                      paddingX: '12px',
                    },
                    '& .Mui-selected': {
                      color: '#1976d2',
                      fontWeight: 700,
                    },
                  }}
                >
                  <Tab label="Fixed Session" />
                  <Tab label="Menu" />
                  <Tab label="Knowledge Data" />
                  <Tab label="Quick Query" />
                  <Tab label="Consultant Banner" />
                </Tabs>
              </Box>

              {fixedSubTab === 0 && <FixedSessionSettingsToggler />}
              {fixedSubTab === 1 && <MenuSettingsToggler />}
              {fixedSubTab === 2 && <KnowledgeDataSettingsToggler />}
              {fixedSubTab === 3 && <QuickQuerySettingsToggler />}
              {fixedSubTab === 4 && <ConsultantHomeBannerDataToggler />}
            </div>
          </TabPanel>
        </div>
      </div>
    </div>
  );
};

export default Settings;

